module.exports = __webpack_public_path__ + "img/cloud-icon.b5a70879.png";